import { DEFAULT_AVATAR } from 'src/assets';

import { Avatar as AvatarComponent } from '../common/Avatar/Avatar';
import { withDefaultAvatar } from '../common/Avatar/withDefaultAvatar';

export const Avatar = withDefaultAvatar(AvatarComponent, DEFAULT_AVATAR);
